import React from 'react';
import * as S from './TermsFooter.styled';
export const TermsFooter = () => {
    return (React.createElement(S.Container, null, "By continuing, you agree to Terms of Use applicable to Fourthwall Pro and confirm you have read our Privacy Policy"));
};
